import {
  LOG_LEVEL_ERROR,
  LOG_LEVEL_WARN,
  LOG_LEVEL_INFO,
  LOG_LEVEL_DEBUG
} from "./constants";

const getMaxLogLevel = () =>
  ({
    [LOG_LEVEL_ERROR]: LOG_LEVEL_ERROR,
    [LOG_LEVEL_WARN]: LOG_LEVEL_WARN,
    [LOG_LEVEL_INFO]: LOG_LEVEL_INFO,
    [LOG_LEVEL_DEBUG]: LOG_LEVEL_DEBUG
  }[process.env.MAX_LOG_LEVEL] || LOG_LEVEL_ERROR);

export default getMaxLogLevel;
